"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const mobx_react_lite_1 = require("mobx-react-lite");
const react_1 = tslib_1.__importStar(require("react"));
const context_1 = require("../../../context");
const SlidingShelf_1 = tslib_1.__importDefault(require("../../../ui-lib/SlidingShelf"));
const ErrorBoundary_1 = require("../../ErrorBoundary");
const ModularSlideSidebar = (0, mobx_react_lite_1.observer)(({ children, onCloseButtonClick, open, ...props }) => {
    const componentName = "<VideoSidebar/>";
    const ctx = (0, react_1.useContext)(context_1.EncoderUiContext);
    (0, ErrorBoundary_1.useUndefinedStoreError)(ctx != null, componentName);
    const toggleVideoCallSlider = () => {
        ctx.viewVideoCallSlider = !ctx.viewVideoCallSlider;
    };
    const handleClick = (0, ErrorBoundary_1.useUIEventError)(toggleVideoCallSlider, componentName);
    return (react_1.default.createElement(SlidingShelf_1.default, { ...props, onCloseButtonClick: onCloseButtonClick !== null && onCloseButtonClick !== void 0 ? onCloseButtonClick : handleClick, open: open !== null && open !== void 0 ? open : ctx === null || ctx === void 0 ? void 0 : ctx.viewVideoCallSlider, variant: "dark" }, children));
});
// eslint-disable-next-line react/function-component-definition
const SlideSidebarWithErrorBoundary = ({ children, ...props }) => {
    return (react_1.default.createElement(ErrorBoundary_1.ErrorBoundary, { render: () => react_1.default.createElement(SlidingShelf_1.default, { ...props }) },
        react_1.default.createElement(ModularSlideSidebar, { ...props }, children)));
};
exports.default = SlideSidebarWithErrorBoundary;
//# sourceMappingURL=VideoCall.js.map